<template>
    <div class="zt-page-content">
        <div class="flex flex-v" style="min-width:920px;height:100%;overflow:hidden;">
            <div style="margin-bottom:0;" class="zt-block flex">
                <div class="flex-1"></div>
                <!-- 商品/商品分类/设计公司 -->
                <div class="input-block flex">
                    <el-input v-model="searchValue" placeholder="产品名、公司名、型号" 
                        prefix-icon="el-icon-search"></el-input>
                    <el-button @click="search">搜索</el-button>
                </div>
                <div style="padding:10px 55px;">
                    <el-button type="primary" @click="toAdd()">新增自有商品</el-button> 
                </div>
            </div>
            <div class="hzzp-list flex-1" ref="list">
                <div v-if="items && items.length>0">
                    <div v-for="(item,idx) in items" :key="idx">
                        <Commodity v-if="materials && colors" :item="item" :materials="materials" :colors="colors" :type="'self'" @onSuccess="onSuccess"></Commodity>
                    </div>
                </div>
            </div>
            <div v-if="pageShow" class="pagination-wrap">
                <el-pagination background layout="prev, pager, next" @current-change="currentChange"
                :current-page.sync="queryOpt.page" :page-size="queryOpt.pagesize"
                :total="total"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
// import _ from 'lodash';
import { getSelfList } from '@/service/factory';
import { materialList, colorList } from "@/service/item";
import Commodity from '@/components/factory/Commodity.vue'
export default {
    components: {
        Commodity
    },
    data() {
        return {
            queryOpt: {
                fname:'',
                pagesize: 5,
                page: 1,
            },
            searchValue:"",
            items:[],
            total:0,
            pageShow:false, // 强制刷新分页组件
            materials:null,
            colors:null,
            power:false, // 判断是否有权限
        }
    },
    // watch: {
    //     'queryOpt.page': {
    //         handler() {
    //             this.$router.push({
    //                 query:{ page:this.queryOpt.page }
    //             });
    //             this.debounceRefreshItems();
    //         },
    //         deep: true
    //     },
    // },
    async created() {
        // this.debounceRefreshItems = _.debounce(this.refreshItems, 500);
        this.materials = await materialList({hasCommon:true});
        this.colors = await colorList({hasCommon:true});
    },
    mounted() {
        if (this.$route.query.page && this.$route.query.page>1) {
            if (this.$route.query.fname) {
                this.queryOpt.fname = this.$route.query.fname;
                this.searchValue = this.queryOpt.fname;
            }
            this.queryOpt.page=parseInt(this.$route.query.page);
            this.refreshItems();
        } else {
            if (this.$route.query.fname) {
                this.queryOpt.fname = this.$route.query.fname;
                this.searchValue = this.queryOpt.fname;
            }
            this.refreshItems();
        }
        this.$nextTick(()=>{
            this.pageShow = true;
        })
    },
    methods: {
        search() {
            if (this.queryOpt.page != this.$route.query.page) {
                this.$router.push({
                    query:{ page:1, fname: this.searchValue}
                });
            }
            this.pageShow = false;
            this.queryOpt.page = 1;
            this.queryOpt.fname = this.searchValue;
            this.refreshItems();
            this.$nextTick(()=>{
                this.pageShow = true;
            })
        },
        currentChange(e) {
            if (this.queryOpt.fname) {
                this.searchValue = this.queryOpt.fname;
                this.$router.push({
                    query:{ page:e, fname: this.queryOpt.fname}
                });
            } else {
                this.$router.push({
                    query:{ page:e }
                });
            }
            this.refreshItems();
        },
        refreshItems(){console.log('getSelfList');
            this.items = [];
            const _loading = this.$loading({
                target:this.$refs.list,
                lock: true,
                text: "拼命加载中....",
            });
            getSelfList(this.queryOpt).then(rst=>{
                this.total=rst.total;
                this.items = rst.list;
                console.log(this.items);
                _loading.close();
            }).catch(err => {
                _loading.close();
                console.log(err);
                this.$message.error(err.message);
                if (err.message == '没有权限') this.power = true;
            });
        },
        onSuccess() {
            getSelfList(this.queryOpt).then(rst=>{
                this.total=rst.total;
                this.items = rst.list;
                console.log(this.items);
            }).catch(err => {
                console.log(err);
                this.$message.error(err.message);
                if (err.message == '没有权限') this.power = true;
            });
        },
        toAdd() {
            if (this.power) {
                this.$message.error("没有权限");
                return;
            }
            this.$router.push('/factory/zysp/submit');
        },
    }
}
</script>

<style src="../style.css"></style>
<style scoped lang="less">
    .zt-page-content {
        .zt-block {
            text-align: right;
            .input-block {
                padding: 10px 0;
                flex-wrap: nowrap;
                .el-input {
                    max-width:200px;
                }
                .el-button {
                    width: 76px;
                    left: -4px;
                    position: relative;
                    z-index: 2;
                }
            }
        }
        
    }
    .hzzp-list{
        width: 100%;
        overflow:auto;
    }
    .hzzp-list>div{
        min-width: 1200px;
    }

    .pagination-wrap {
        padding:12px 55px;
        text-align:center;
    }
</style>